<template>
<div id="SMFAdmin">
  <div class="container">
    <h1>Administration</h1>
  </div>
</div>
</template>

<script>

export default {
  name: 'Admin',
  data () {
    return {
      url: '/plog/index.json',
      status: 'loading...',
      contentLength: 0,
      content: [],
      entry: ''
    }
  },
  mounted () {
  },
  methods: { 
  }
}
</script>

<style>
figure {
  margin: 2%;
}
aside {
  float: right;
  width: 20%;
  text-align: center;
}
.docscript-img {
  max-width: 95%;
  border: 2px solid #777;
}
.docscript-img:hover {
  box-shadow: 0 0 10px #ccc;
}
.docscript-footnote {
  margin-bottom: 0rem;
}
#SMFPlog{
  background: rgb(220,226,226);
}
.plog-index {
  margin-top:2rem;
  margin-bottom:2rem;
}
</style>
